import axios from 'axios'

export const companiesRegistrationsInfo = {
  namespaced: true,
  state: {
    data: {
      company: {
        name: '',
        phone_number: '',
        agency_code: {
          value: ''
        },
      },
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      token: '',
      plan_id: null
    },
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    initPlanId(state) {
      state.data.plan_id = null
    },
    changePlanId(state, planId) {
      state.data.plan_id = planId
    },
    initCompanyAgencyCode(state, agency_code) {
      state.data.company.agency_code.value = agency_code
    },
    writeRegistrationsInfo(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    writeRegistrationsInfoSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    writeRegistrationsInfoFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
      alert(state.errors.map(data => data.detail).join('\n'))
    }
  },
  actions: {
    initPlanId({ commit }) {
      commit('initPlanId')
    },
    changePlanId({ commit }, planId){
      commit('changePlanId', planId)
    },
    initCompanyAgencyCode({ commit }, agency_code ) { 
      commit('initCompanyAgencyCode', agency_code)
    },
    writeRegistrationsInfo({ commit, state }) {
      if (state.loading) return
      const payjsToken =  document.getElementsByName('payjp-token')[0].value
      if (!payjsToken) {
        alert('お支払い情報を入力してください')
        return
      }
      commit('writeRegistrationsInfo')
      state.data.token = payjsToken
      // ディープコピー
      const payload = JSON.parse(JSON.stringify(state.data))
      if (!state.data.company.agency_code.value) delete payload.company.agency_code
      return axios
        .post('/api/companies/registrations/info', payload)
        .then(res => {
          commit('writeRegistrationsInfoSuccess', res.data)
          return true
        })
        .catch(err => {
          commit('writeRegistrationsInfoFailure', err.response.data.errors)
          console.error(err)
          return false
        })
    }
  }
}
